const isProd = process.env.NODE_ENV === "production";
const ENV_BASE = process.env.REACT_APP_API_URL || process.env.VITE_API_URL;
const RUNTIME_BASE = typeof window !== "undefined" ? window.__API_BASE__ : undefined;
const API_BASE = ENV_BASE || RUNTIME_BASE || (isProd ? "/api" : "http://localhost:3001");

async function http(method, path, body) {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: body ? JSON.stringify(body) : undefined,
  });
  const isJson = (res.headers.get("content-type") || "").includes("application/json");
  const data = isJson ? await res.json().catch(() => ({})) : await res.text().catch(() => "");
  if (!res.ok) {
    const msg = (data && (data.error || data.message)) || res.statusText;
    throw new Error(msg || `HTTP ${res.status}`);
  }
  return data;
}

export const auth = {
  me: () => http("GET", "/auth/me"),
  login: async (email, password) => {
    const res = await http("POST", "/auth/login", { email, password });
    localStorage.setItem("auth_event", Date.now()); // trigger refresh
    window.dispatchEvent(new Event("storage")); // immediate same-tab refresh
    return res;
  },
  logout: async () => {
    const res = await http("POST", "/auth/logout");
    localStorage.setItem("auth_event", Date.now());
    window.dispatchEvent(new Event("storage"));
    return res;
  },
};